// Yotpo schrijft het aantal beoordelingen als "( 68 reviews )", met spaties
// binnen de haakjes. Dat zit in de tekst zelf, dus CSS kan er niets aan doen.
// De widgets worden pas na het laden en soms opnieuw getekend (bij elke kaart
// op een collectiepagina, en na filteren of verder laden), vandaar een
// observer die de tekst telkens rechtzet zodra Yotpo hem neerzet.
//
// Zelfde moment: staat er "(0 reviews)", dan krijgt het widget de klasse
// is-empty en verbergt de CSS het. Vijf lege sterren zeggen niets en ogen als
// een slechte score. Op het widget zelf (.yotpo-widget-instance, ons element,
// niet dat van Yotpo), zodat het ook geldt voor de sterren in het app-blok op
// mobiel.
(() => {
  const SELECTOR = '.yotpo-sr-bottom-line-text';

  // Alleen de tekstknopen zelf, niet textContent van het element: dat zou
  // eventuele kindelementen van Yotpo weggooien.
  const markEmpty = (element) => {
    const widget = element.closest('.yotpo-widget-instance');
    const match = element.textContent.match(/\d+/);

    if (widget && match) {
      widget.classList.toggle('is-empty', parseInt(match[0], 10) === 0);
    }
  };

  const tidy = (element) => {
    markEmpty(element);

    element.childNodes.forEach((node) => {
      if (node.nodeType !== Node.TEXT_NODE) {
        return;
      }

      const text = node.nodeValue;
      const tidied = text.replace(/\(\s+/g, '(').replace(/\s+\)/g, ')');

      // Alleen schrijven als er iets verandert, anders vuurt de observer
      // hieronder op zijn eigen wijziging en blijft hij draaien.
      if (tidied !== text) {
        node.nodeValue = tidied;
      }
    });
  };

  const tidyWithin = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    if (root.matches(SELECTOR)) {
      tidy(root);
    }

    root.querySelectorAll(SELECTOR).forEach(tidy);
  };

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        const element = mutation.target.parentElement && mutation.target.parentElement.closest(SELECTOR);

        if (element) {
          tidy(element);
        }

        return;
      }

      mutation.addedNodes.forEach(tidyWithin);
    });
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  tidyWithin(document.body);
})();
